<template>
  <div v-if="event.enable_filtering">
    <a 
      v-if="isBookmarked" 
      class="agenda-block-bookmarked" 
      :aria-label="bookmarkedAriaLabel" 
      @click="removeBookmark"
    >
      <i class="fa fa-bookmark"></i>
    </a>
    
    <a 
      v-if="!isBookmarked" 
      class="agenda-block-bookmark" 
      :aria-label="bookmarkAriaLabel" 
      @click="bookmarkScheduleItem"
    >
      <i class="far fa-bookmark"></i>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
    event: Object,
    eventAttendee: Object,
    storeUrl: String,
    destroyUrl: String,
  },
  data() {
    return {
      isBookmarked: this.item.bookmark
    }
  },
  computed: {
    bookmarkedAriaLabel() {
      return `Agenda ${this.item.id} Bookmarked`;
    },
    bookmarkAriaLabel() {
      return `Agenda ${this.item.id} Bookmark`;
    }
  },
  methods: {
    async bookmarkScheduleItem() {
        const form = {
            event_id: this.event.id,
            bookmark_plugin_type: 'ScheduleItem',
            bookmark_plugin_id: this.item.id,
            event_attendee_id: this.eventAttendee.id,
            name: this.item.name,
        };

        try {
            const response = await $.ajax({
                url: this.storeUrl,
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                method: 'POST',
                data: form
            });
            this.isBookmarked = true
        } catch (e) {
            console.error('Error adding bookmark', e);
        }
    },
    async removeBookmark() {
      const url = `${this.destroyUrl.replace(':bookmarkId', this.item.id)}&bookmark_plugin_type=ScheduleItem`;
        
      try {
          const response = await $.ajax({
              url: url,
              headers: {
                  'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                  'Content-Type': 'application/x-www-form-urlencoded'
              },
              method: 'DELETE'
          });
          this.isBookmarked = false
      } catch (e) {
          console.error('Error removing bookmark', e);
      }
    },
  }
}
</script>
